import apiClient from '../api/apiClient';

interface SupportContactResponse {
  userName: string;
  contact: string;
}

/**
 * Support Contact Service
 * Fetches pharmacy member services support contact details
 */
class SupportService {
  /**
   * Fetches support contact details from SOA API
   * 
   * @param sessionId - The session ID for authentication
   * @returns Support contact phone number or null if unavailable
   */
  static async getSupportContactDetails(
    sessionId: string
  ): Promise<string | null> {
    try {
      const response = await apiClient.post<SupportContactResponse>(
        `/carelonrx/supportContactDetails?sessionId=${sessionId}`,
        {}
      );

      return response.data?.contact || null;
    } catch (error) {
      console.error('Failed to fetch support contact details:', error);
      throw error;
    }
  }
}

export default SupportService;
